// extracted by mini-css-extract-plugin
export default {"zoom-overlay-thumbnail-container":"s4F0vV32GJloYJLYG4Py","zoomOverlayThumbnailContainer":"s4F0vV32GJloYJLYG4Py"};